import { Button, ButtonProps } from '@mui/material'
import { Refresh } from '@mui/icons-material'
import StyledLink from 'components/StyledLink'
import { IAPIError } from 'types'

interface IErrorActionButtonProps extends Omit<ButtonProps, 'component'> {
  retry?: () => void
  error?: IAPIError
}

export default function ErrorActionButton({ error, retry, ...props }: IErrorActionButtonProps) {
  if (error?.name === 'BillingPlanIncompatibleError') {
    return (
      <Button
        color="primary"
        {...props}
        component={StyledLink as any} // TODO: figure out why this is causing a type error together with ...props
        href="/company/plans"
      >
        Upgrade Options
      </Button>
    )
  }

  if (error?.name === 'BillingSetupRequiredError') {
    return (
      <Button
        color="primary"
        {...props}
        component={StyledLink as any} // TODO: figure out why this is causing a type error together with ...props
        href="/company/plans"
      >
        Complete Setup
      </Button>
    )
  }

  if (retry) {
    return (
      <Button
        color="primary"
        {...props}
        onClick={retry}
        startIcon={<Refresh />}
      >
        Retry
      </Button>
    )
  }

  return null
}
